import React from 'react';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: "Sarah Martinez",
    role: "Registered Nurse",
    location: "Austin, TX",
    content: "SkillBinder helped me negotiate a $8,000 salary increase by showing me exactly what nurses in my area were earning. The career plan was spot-on for my specialty.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=100&h=100&fit=crop&crop=face"
  },
  {
    name: "Mike Thompson",
    role: "Electrician",
    location: "Denver, CO", 
    content: "As a journeyman electrician, the trade-specific exercises and certification tracking helped me become a master electrician 6 months ahead of schedule.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face"
  },
  {
    name: "Jessica Chen",
    role: "Hair Stylist",
    location: "San Francisco, CA",
    content: "The client management tools and local salary insights helped me price my services correctly and build a loyal customer base. Revenue up 40%!",
    rating: 5,
    avatar: "/assets/images/male_mechanic.png"
  }
];

const stats = [
  { number: "10,000+", label: "Active users" },
  { number: "87%", label: "Career advancement rate" },
  { number: "$12,000", label: "Average salary increase" },
  { number: "4.8/5", label: "User satisfaction" }
];

export default function SocialProof() {
  return (
    <section className="py-20 bg-secondary/5">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        
        {/* Stats */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-2">
            Trusted by professionals everywhere
          </h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats?.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-primary mb-2">
                  {stat?.number}
                </div>
                <div className="text-muted-foreground text-sm md:text-base">
                  {stat?.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {testimonials?.map((testimonial, index) => (
            <div key={index} className="bg-card rounded-2xl p-6 border border-border hover:shadow-lg transition-all duration-300 hover:border-primary/20">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial?.rating || 5)]?.map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              
              <div className="relative mb-4">
                <Quote className="absolute -top-2 -left-2 w-8 h-8 text-primary/20" />
                <p className="text-muted-foreground italic leading-relaxed pl-6">
                  "{testimonial?.content}"
                </p>
              </div>
              
              <div className="flex items-center gap-3">
                <img 
                  src={testimonial?.avatar} 
                  alt={testimonial?.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = '/assets/images/no_image.png';
                  }}
                />
                <div>
                  <div className="font-semibold text-foreground text-sm">
                    {testimonial?.name}
                  </div>
                  <div className="text-muted-foreground text-xs">
                    {testimonial?.role} • {testimonial?.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-8 opacity-60">
          <div className="text-center">
            <div className="text-xs text-muted-foreground mb-1">SECURED BY</div>
            <div className="font-semibold text-foreground">Stripe</div>
          </div>
          <div className="text-center">
            <div className="text-xs text-muted-foreground mb-1">GDPR</div>
            <div className="font-semibold text-foreground">Compliant</div>
          </div>
          <div className="text-center">
            <div className="text-xs text-muted-foreground mb-1">SOC 2</div>
            <div className="font-semibold text-foreground">Certified</div>
          </div>
        </div>
      </div>
    </section>
  );
}